module.exports = __webpack_public_path__ + "img/IND.1c05bdb3.png";